import axios from "axios";

export const state = {
  isAvailableExternalOfficeLoading: false,
};
export const mutations = {
  setIsAvailableExternalOfficeLoading(state, value) {
    state.isAvailableExternalOfficeLoading = value;
  },
};
export const actions = {
  getAvailableExternalOfficesByDUId(context, deliveryUnitId) {
    return axios.get(`/Core/DeliveryUnitExternalOffice/Available/${deliveryUnitId}`);
  },
  getDeliveryUnitExternalOfficeByDeliveryUnitId(context, deliveryUnitId) {
    return axios.get(`/Core/DeliveryUnitExternalOffice/DeliveryUnit/${deliveryUnitId}`);
  },
  createDeliveryUnitExternalOffice(context, data) {
    return axios.post(`/Core/DeliveryUnitExternalOffice/Create`, data);
  },
  deleteDeliveryUnitExternalOfficeById(context, { deliveryUnitId, officeId }) {
    return axios.delete(`/Core/DeliveryUnitExternalOffice/Delete/${deliveryUnitId}/${officeId}`);
  },
};
